import React from 'react';
import AppLayout from 'containers/layout/AppLayout';
import { AppContext } from 'context/AppContext';
import { LoggingContext } from 'context/LoggingContext';
import { SignalRContext } from 'context/SignalRContext';
import { SoundContext } from 'context/SoundContext';
import { ThemeContext } from 'context/ThemeContext';
import { Provider as ReduxProvider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'store';
import 'swiper/css';

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <ThemeContext>
        <SignalRContext>
          <AppLayout />
        </SignalRContext>
      </ThemeContext>
    ),
  },
]);

function App() {
  return (
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <LoggingContext>
          <SoundContext>
            <AppContext>
              <RouterProvider router={router} />
            </AppContext>
          </SoundContext>
        </LoggingContext>
      </PersistGate>
    </ReduxProvider>
  );
}

export default App;
